import { getProductsByCategoryId } from "@/services/category";
import { getMultiProductsRating } from "@/services/product/reviews";
import { getCookies } from "cookies-next";
import { useCallback, useEffect, useState } from "react";
import useSWRMutation from "swr/mutation";
import useClearPLPProductsCache from "./useClearCachePLPProducts";

const useFilterProducts = ({ setAllFilterKeys, setAllProducts, categoryID, filters, allSortingKeys }) => {
  const [selectedFilterKeys, setSelectedFilterKeys] = useState([]);
  const [allFilters, setAllFilters] = useState(filters);
  const { handshake } = getCookies()
  const {clearPLPProductsCache} = useClearPLPProductsCache(categoryID)

  const res = useSWRMutation(
    `/api/category/pages/getMoreProducts?pageIdx=0&categoryID=${categoryID}`,
    async (_, { arg }) => {
      return await getProductsByCategoryId(
        handshake,
        categoryID,
        arg?.pageSize,
        arg?.pageNo,
        arg?.filterKeys,
        arg?.sortKeys
      );
    },
    {
      revalidateOnMount: 30 * 60 * 1000, // 30 minutes in milliseconds
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      populateCache: true,
    }
  );

  useEffect(() => {
    setAllFilters(filters)
  }, [filters]);

  // useEffect(() => {
  //   setSelectedFilterKeys([])
  //   setAllFilterKeys("")
  //   return () => {
  //     setSelectedFilterKeys([])
  //     setAllFilterKeys("")
  //   };
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const handleFilter = useCallback(
    async ({ code, item }) => {

      let filterKeys = ''
      if (selectedFilterKeys?.includes(`${code}=${item?.Key}`)) {
        const updatedSelectedFilterKeys = selectedFilterKeys?.filter(
          (itemF) => itemF != `${code}=${item?.Key}`
        );
        setSelectedFilterKeys(updatedSelectedFilterKeys);
        filterKeys = `${updatedSelectedFilterKeys?.join("&")}`
      } else {
        setSelectedFilterKeys((prev) => [...prev, `${code}=${item?.Key}`]);
        filterKeys = `${selectedFilterKeys?.join("&")}&${code}=${item?.Key}`
      }

      setAllFilterKeys(filterKeys)

      clearPLPProductsCache()

      let resResult = await res?.trigger({
        pageNo: 0,
        pageSize: 30,
        categoryID,
        filterKeys
      });
      
      const result = resResult?.data?.data || {};

      if (result?.products?.length && result?.products != undefined) {
        const skus = [... new Set(...result?.products?.map(product => product?.sku))];
     
        const ratings = await getMultiProductsRating(skus?.flat(), handshake);
      
        const enhancedProducts = result?.products?.map(product => ({
          ...product,
          rating: Object.entries(ratings?.data?.data?.at(1))?.find(r => r?.at(0) === product?.sku)?.at(1) || { count: "0", rating: "0.0" },
        }))
        
        setAllProducts(enhancedProducts);
      }

    },

    [categoryID, clearPLPProductsCache, handshake, res, selectedFilterKeys, setAllFilterKeys, setAllProducts]
  );

  const handleResetFilter = async () => {
    setSelectedFilterKeys([]);
    clearPLPProductsCache()

    let resResult = await res?.trigger({
      pageNo: 0,
      pageSize: 30,
      categoryID,
      filterKeys: "",
      sortKeys: allSortingKeys
    });

    const result = resResult?.data?.data || {};

    result?.products?.length &&
      result?.products != undefined &&
      setAllProducts(result?.products);
  };

  return {
    selectedFilterKeys, 
    setSelectedFilterKeys,
    handleFilter,
    handleResetFilter,
    allFilters
  };
};

export default useFilterProducts;
